<template>
    <el-table-column :class-name="`x-column${config.sortable ? ' sortable' : ''}`" v-if="config.visible !== false"
        :type="getColumnType(config)"
        :index="config.type == 'index' ? indexFunc : null"
        :align="getColumnAlign(config)"
        :header-align="getHeaderAlign(config)"
        :label="config.name"
        :prop="config.field"
        :width="(!config.cihldren || !config.children.length) ? (config.width || 200) : undefined"
        :fixed="config.fixed"
        :resizable="config.resizable != false"
    >
        <template #header>
            <div v-for="(title, index) in getColumnNames(config.name)" :key="index">{{title}}</div>
            <div class="sort-flag" v-if="config.sortable">
                <el-icon v-if="config.sortAccord == 'DESC'"><CaretBottom /></el-icon>
                <el-icon v-if="config.sortAccord == 'ASC'"><CaretTop /></el-icon>
            </div>
            <span class="dragger" v-if="config.resizable != false"></span>
        </template>
        <template v-if="!isFixedLayout(config)" #default="scope">
            <x-item v-if="scope" 
                :config="config" 
                :readonly="readonly"
                :data="scope.row" 
                :field="config.field"
                @button-click="(button)=>$emit('buttonClick', button, scope.row, config)"
                @link-click="(value)=>$emit('linkClick', value, scope.row, config)"
            ></x-item>
        </template>
        <template v-if="config.children && config.children.length">
            <x-column v-for="(child, index) in config.children" :key="index" :column="child"></x-column>
        </template>
    </el-table-column>
</template>
<script setup>
import { defineProps } from 'vue';
import { CaretBottom, CaretTop } from '@element-plus/icons-vue';
import FieldType from '../../datamodule/FieldType';
import XItem from './XItem.vue';

const props = defineProps({
    config: { default: null },
    indexFrom: { default: 0 },
    readonly: { default: false },
})

defineEmits({
    'buttonClick': null,
    'linkClick': null,
})

const getColumnType = (config)=> {
    switch (config.type) {
        case FieldType.INDEX: return 'index';
        case FieldType.LISTSELECTION: return 'selection';
        default: return null;
    }
}

const getColumnAlign = (config)=> {
    if (config.align) return config.align;
    if (config.dataType == 'text' || config.dataType == 'string') return 'left';
    else return 'center';
}
const getHeaderAlign = (config)=> {
    return config.headerAlign || 'center';
}

const getColumnNames = (name)=> {
    if (!name) return null;
    return name.split(/\r/);
}

const indexFunc = (index)=> {
    return props.indexFrom + index + 1;
}

const isFixedLayout = (config)=> {
    return config.type == FieldType.INDEX || config.type == FieldType.LISTSELECTION || (config.children && config.children.length);
}
</script>
<style>
    .x-column.sortable {
        cursor: pointer;
    }
    .x-column .sort-flag {
        position: absolute;
        right: 0;
        top: 0;
        margin-right: 5px;
        pointer-events: none;
    }
</style>